export enum ServiceTypes {
  Minor = 1,
  Intermediate = 2,
  Major = 3,
}